var _linearGradient, _filter, _style, _image, _path, _image2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCodeBlock = function SvgCodeBlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 22.63 22.63"
  }), /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "code-block_svg__linear-gradient",
    x1: 11.31,
    y1: 0,
    x2: 11.31,
    y2: 22.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a2dbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#7c2fbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#8435c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#8334c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8d3cd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8a3ace"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#7129b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#5e1ca6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#53159d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50139a"
  }))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "code-block_svg__luminosity-invert",
    x: -2.8,
    y: -2.38,
    width: 28,
    height: 28,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "cm",
    values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".code-block_svg__cls-3{fill:#eae9e9}.code-block_svg__cls-4{mix-blend-mode:multiply;opacity:.4}")), /*#__PURE__*/React.createElement("mask", {
    id: "code-block_svg__mask",
    x: -2.8,
    y: -2.38,
    width: 28,
    height: 28,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("image", {
    width: 28,
    height: 28,
    transform: "translate(-2.8 -2.38)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAAAsSAAALEgHS3X78AAABk0lEQVRIie3WMW6DMBQG4B9Tx0NAMHAEkOAyOQNcIffIATJykkTKygEYkMLADBLyklj261AVKYnbpiqNqir/aD/5E7ZlngOA8MCwR2IA8HI9UBQFsixDEATgnIMxBsdx7lpMaw2lFPq+R13XKMvyc3C9XmO1WiFJEvi+DyEEGHvbhK9QIprAYRjQti2iKMJms7mtBUBFUdB+vycpJc2R0+lEu92O8jyndwMATWeYZRmSJMFyubxr+77KYrFAHMdI0/RifAKDIIDv+7Ng7/E8D2EY2kHOOYQQs4JCCHDO7SBjbLogc4UxBtd17eC9V/87cRznZl12XfDbefhL8wSf4N8CiQhEl/93dl0wZ4wxMMbYQa01tNazgkopKKXsoG3yp5FSYhxHO9j3PYZhmA0zxqDrOjRNYwfrukbbtjifz7Ngx+MRVVVhu91ezE09TVmWiKIIWmvEcQzP86ae5p5+xhgDpRSklOi6DlVV4XA43NQ6uOpL8zxHmqYIwxCcc7iu+y1wHEc0TXPzZR+Cv53/9dLY8gok2/SNtZ1atAAAAABJRU5ErkJggg==",
    style: {
      filter: "url(#code-block_svg__luminosity-invert)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "code-block_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "code-block_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.63,
    height: 22.63,
    rx: 5.11,
    ry: 5.11,
    style: {
      fill: "url(#code-block_svg__linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#code-block_svg__mask)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.63,
    height: 22.63,
    rx: 5.11,
    ry: 5.11,
    style: {
      opacity: 0.6
    }
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    className: "code-block_svg__cls-4",
    width: 7,
    height: 10,
    transform: "translate(3.19 6.6)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAACXBIWXMAAAsSAAALEgHS3X78AAAAOUlEQVQYlWNgIAAYsYj9R5ZnwiOJYgKGBEwO3QQMq7EpQHEXNgUo1jHikoDJI5uAzcsYVmBVhBcAAGTpBRImZBPiAAAAAElFTkSuQmCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "code-block_svg__cls-3",
    d: "M8.49 7.01s.11-.11.21-.02.55.58.7.89.21.34.04.46-4.01 2.92-4.01 2.92-.11.02.06.14 4 2.96 4 2.96.09.09.05.15-.88 1.09-.88 1.09-.14.14-.28.03-3.8-2.83-3.8-2.83-.86-.63-.85-1.45.52-1.19 1.08-1.67S8.48 7 8.48 7Z"
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    className: "code-block_svg__cls-4",
    width: 7,
    height: 10,
    transform: "translate(12.19 6.6)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAACXBIWXMAAAsSAAALEgHS3X78AAAAPklEQVQYlYWOQQ4AIAjDivH/X8aLmoBDdiFhKwwa2Z4udgAMAXkXCCGrjOPnCxlgfuhAKNOgLnlfqcDT46sFP5gGEjg0RQ4AAAAASUVORK5CYII="
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "code-block_svg__cls-3",
    d: "M14.13 7.01s-.11-.11-.21-.02-.55.58-.7.89-.21.34-.04.46 4.01 2.92 4.01 2.92.11.02-.06.14-4 2.96-4 2.96-.09.09-.05.15.88 1.09.88 1.09.14.14.28.03 3.8-2.83 3.8-2.83.86-.63.85-1.45-.52-1.19-1.08-1.67S14.14 7 14.14 7Z"
  }))))));
};
export default SvgCodeBlock;